// import React, { useEffect, useState } from "react";
// import {
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   Link,
//   CircularProgress,
//   Typography,
// } from "@mui/material";
// import axios from "axios";
// import Urls from "@egovernments/digit-ui-libraries/src/services/atoms/urls";

// const UserManualTable = ({ formType ,isSubApproved}) => {
//   const [tableData, setTableData] = useState([]);
//   const [loading, setLoading] = useState(true);

//   const fetchManualData = async () => {
//     try {
//       const dataToSend = {
//         RequestInfo: {
//           apiId: "Rainmaker",
//           action: "_create",
//           did: 1,
//           key: "",
//           msgId: "20170310130900|en_IN",
//           ts: 0,
//           ver: ".01",
//         },
//       };

//       const response = await axios.post(
//         `${Urls.UserManualSearch}?isApproved=${formType}&isSubApproved=${isSubApproved}`,
//         dataToSend
//       );

//       console.log("📘 Response From User Manual API:", response.data);

//       // ✅ Fix: Map correct key
//       setTableData(response.data?.UserManual || []);
//     } catch (error) {
//       console.error("❌ Error fetching user manual data:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchManualData();
//   }, [formType]);

//   if (loading) {
//     return (
//       <Paper
//         elevation={0}
//         sx={{
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//           height: 180,
//           backgroundColor: "#f8fafc",
//         }}
//       >
//         <CircularProgress size={28} sx={{ color: "#0c5a88" }} />
//         <Typography sx={{ ml: 2, color: "#0c5a88" }}>
//           Loading documents...
//         </Typography>
//       </Paper>
//     );
//   }

//   return (
//     <TableContainer
//       component={Paper}
//       sx={{
//         maxHeight: 300,
//         overflow: "auto",
//         borderRadius: 2,
//         boxShadow: 1,
//       }}
//     >
//       <Table size="small">
//         <TableHead sx={{ backgroundColor: "#e0edf8" }}>
//           <TableRow>
//             <TableCell sx={{ fontWeight: 600 }}>S.No.</TableCell>
//             <TableCell sx={{ fontWeight: 600 }}>Category</TableCell>
//             <TableCell sx={{ fontWeight: 600 }}>User Manual</TableCell>
//             <TableCell sx={{ fontWeight: 600 }}>Description</TableCell>
//             <TableCell sx={{ fontWeight: 600 }}>Updated On</TableCell>
//             <TableCell sx={{ fontWeight: 600 }}>Download Link</TableCell>
//             {/* <TableCell sx={{ fontWeight: 600 }}>isApproval</TableCell> */}
//           </TableRow>
//         </TableHead>

//         <TableBody>
//           {tableData.length > 0 ? (
//             tableData.map((row, index) => (
//               <TableRow key={row.id || index}>
//                 <TableCell>{index + 1}</TableCell>
//                 <TableCell>{row.category || "—"}</TableCell>
//                  <TableCell>{row.isSubApproved || "—"}</TableCell>
//                 <TableCell>{row.description || "—"}</TableCell>

//                 {/* Convert createdTime to readable date */}
//                 <TableCell>
//                   {row.auditDetails?.createdTime
//                     ? new Date(row.auditDetails.createdTime).toLocaleDateString()
//                     : "—"}
//                 </TableCell>

//                 <TableCell>
//                   {row.downloadLink ? (
//                     <Link
//                       href={row.downloadLink}
//                       target="_blank"
//                       rel="noopener"
//                       sx={{ color: "#0c5a88", fontWeight: 500 }}
//                     >
//                       Download
//                     </Link>
//                   ) : (
//                     "—"
//                   )}
//                 </TableCell>

//                 {/* <TableCell>
//                   {row.isApproved === "manual" ? "Yes" : "No"}
//                 </TableCell> */}
//               </TableRow>
//             ))
//           ) : (
//             <TableRow>
//               <TableCell colSpan={6} align="center">
//                 No data available
//               </TableCell>
//             </TableRow>
//           )}
//         </TableBody>
//       </Table>
//     </TableContainer>
//   );
// };

// export default UserManualTable;

import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Link,
  CircularProgress,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
} from "@mui/material";
import axios from "axios";
import Urls from "@egovernments/digit-ui-libraries/src/services/atoms/urls";

const UserManualTable = ({ formType, isSubApproved }) => {
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editRow, setEditRow] = useState(null);
  const [editData, setEditData] = useState({});
  const [deletingId, setDeletingId] = useState(null);

  // 🔹 Fetch table data
  const fetchManualData = async () => {
    try {
      const dataToSend = {
        RequestInfo: {
          apiId: "Rainmaker",
          action: "_create",
          did: 1,
          key: "",
          msgId: "20170310130900|en_IN",
          ts: 0,
          ver: ".01",
        },
      };

      const response = await axios.post(
        `${Urls.UserManualSearch}?isApproved=${formType}&isSubApproved=${isSubApproved}`,
        dataToSend
      );

      console.log("📘 Response From User Manual API:", response.data);
      setTableData(response.data?.UserManual || []);
    } catch (error) {
      console.error("❌ Error fetching user manual data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchManualData();
  }, [formType]);

  // 🗑 Delete record by id
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this manual?")) return;

    try {
      setDeletingId(id);
      const payload = {
        RequestInfo: {
          apiId: "Rainmaker",
          action: "_create",
          did: 1,
          key: "",
          msgId: "20170310130900|en_IN",
          ts: 0,
          ver: ".01",
        },
      };

      // Replace with actual DELETE API endpoint
      await axios.post(`${Urls.UserManualDelete}?id=${id}`, payload);
      console.log("PayloadDelete",payload);
      
      alert("Deleted successfully!");
      fetchManualData(); // refresh
    } catch (error) {
      console.error("❌ Delete failed:", error);
      alert("Delete failed. Please try again.");
    } finally {
      setDeletingId(null);
    }
  };

  // ✏️ Edit record dialog open
  const handleEdit = (row) => {
    setEditRow(row.id);
    setEditData({ ...row });
  };

  // 💾 Save edited data (id-based)
  const handleSave = async () => {
    try {
      const payload = {
        RequestInfo: { apiId: "Rainmaker" },
        UserManual: [editData],
      };

      // Replace with actual update API endpoint
      await axios.post(`${Urls.UserManualUpdate}`, payload);
      alert("Updated successfully!");
      setEditRow(null);
      fetchManualData();
    } catch (error) {
      console.error("❌ Update failed:", error);
      alert("Update failed. Please try again.");
    }
  };

  // 🌀 Loading state
  if (loading) {
    return (
      <Paper
        elevation={0}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: 180,
          backgroundColor: "#f8fafc",
        }}
      >
        <CircularProgress size={28} sx={{ color: "#0c5a88" }} />
        <Typography sx={{ ml: 2, color: "#0c5a88" }}>
          Loading documents...
        </Typography>
      </Paper>
    );
  }

  // 🧾 Table UI
  return (
    <React.Fragment>
      <TableContainer
        component={Paper}
        sx={{
          maxHeight: 400,
          overflow: "auto",
          borderRadius: 2,
          boxShadow: 1,
        }}
      >
        <Table size="small">
          <TableHead sx={{ backgroundColor: "#e0edf8" }}>
            <TableRow>
              <TableCell sx={{ fontWeight: 600 }}>S.No.</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Category</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>User Manual</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Description</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Updated On</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Download Link</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Actions</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {tableData.length > 0 ? (
              tableData.map((row, index) => (
                <TableRow key={row.id || index}>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>{row.category || "—"}</TableCell>
                  <TableCell>{row.isSubApproved || "—"}</TableCell>
                  <TableCell>{row.description || "—"}</TableCell>
                  <TableCell>
                    {row.auditDetails?.createdTime
                      ? new Date(
                          row.auditDetails.createdTime
                        ).toLocaleDateString()
                      : "—"}
                  </TableCell>
                  <TableCell>
                    {row.downloadLink ? (
                      <Link
                        href={row.downloadLink}
                        target="_blank"
                        rel="noopener"
                        sx={{ color: "#0c5a88", fontWeight: 500 }}
                      >
                        Download
                      </Link>
                    ) : (
                      "—"
                    )}
                  </TableCell>
                  <TableCell sx={{display:"flex"}}>
                    <Button
                      size="small"
                      variant="outlined"
                      color="primary"
                      onClick={() => handleEdit(row)}
                      sx={{ mr: 1 }}
                    >
                      Edit
                    </Button>
                    <Button
                      size="small"
                      variant="outlined"
                      color="error"
                      disabled={deletingId === row.id}
                      onClick={() => handleDelete(row.id)}
                    >
                      {deletingId === row.id ? "Deleting..." : "Delete"}
                    </Button>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={7} align="center">
                  No data available
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* ✏️ Edit Dialog */}
      <Dialog open={Boolean(editRow)} onClose={() => setEditRow(null)} maxWidth="sm" fullWidth>
        <DialogTitle>Edit User Manual</DialogTitle>
        <DialogContent>
          <TextField
            margin="dense"
            label="Category"
            fullWidth
            value={editData.category || ""}
            onChange={(e) =>
              setEditData({ ...editData, category: e.target.value })
            }
          />
          <TextField
            margin="dense"
            label="Description"
            fullWidth
            value={editData.description || ""}
            onChange={(e) =>
              setEditData({ ...editData, description: e.target.value })
            }
          />
          <TextField
            margin="dense"
            label="Download Link"
            fullWidth
            value={editData.downloadLink || ""}
            onChange={(e) =>
              setEditData({ ...editData, downloadLink: e.target.value })
            }
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setEditRow(null)}>Cancel</Button>
          <Button onClick={handleSave} variant="contained">
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default UserManualTable;

